module.exports = __webpack_public_path__ + "static/media/lightbulb_4.956e570e.png";